import React, { FC, useMemo } from "react";

import { useProvidersCurrentEmployee } from "~/hooks";

import { getMemberNavigationConfig } from "~/config/NavigationConfig";

import { SidebarLink } from "./SidebarLink";
import { SidebarSectionHeader } from "./SidebarSectionHeader";

import {
  ApiMembersUnreadNotificationCountsType,
  NavigationItemCompanyType,
} from "~/domains";

type PropsType = {
  breadCrumbText: string;
  unreadNotification?: ApiMembersUnreadNotificationCountsType;
  navigationItems?: NavigationItemCompanyType[];
};

export const MemberSidebar: FC<PropsType> = ({
  breadCrumbText,
  unreadNotification,
  navigationItems,
}: PropsType) => {
  const { currentEmployee } = useProvidersCurrentEmployee();
  const defaultBusinessSectionId =
    currentEmployee?.businessSections[0]?.id || "";

  const navigationConfig = useMemo(
    () => getMemberNavigationConfig(defaultBusinessSectionId),
    [defaultBusinessSectionId],
  );

  const displayNavs = navigationItems
    ?.filter((item) => item.role === "member" && !item.hiddenAt)
    .sort((a, b) => a.position - b.position);

  return (
    <>
      {navigationConfig.map((group, groupIndex) => {
        const groupNavs =
          displayNavs?.filter((nav) => nav.name in group.items) || [];
        if (groupNavs.length === 0) return null;

        return (
          <React.Fragment key={group.section}>
            {groupIndex > 0 && <SidebarSectionHeader title={group.section} />}
            {groupNavs.map((nav) => {
              const config = group.items[nav.name];
              return config?.href ? (
                <SidebarLink
                  key={nav.name}
                  label={nav.name}
                  href={config.href}
                  breadCrumbText={breadCrumbText}
                  unreadNotification={unreadNotification}
                  icon={config.icon}
                />
              ) : null;
            })}
          </React.Fragment>
        );
      })}
    </>
  );
};
